import { render } from "./UserProfileCardEditorRandomAvatar.vue?vue&type=template&id=ba5e90bc"
import script from "./UserProfileCardEditorRandomAvatar.vue?vue&type=script&lang=js"
export * from "./UserProfileCardEditorRandomAvatar.vue?vue&type=script&lang=js"
script.render = render

export default script